"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkSyncErpInfo = checkSyncErpInfo;
exports.getConfigErpKey = getConfigErpKey;
var _request = _interopRequireDefault(require("@/utils/request"));
var _cloud = require("@/utils/cloud");
// 根据erp参数，获取显隐按钮的回调
function getConfigErpKey() {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/check/cache/erpInfo',
    method: 'get'
  });
}

// 根据erp的参数，获取按钮点击后的回调
function checkSyncErpInfo() {
  return (0, _request.default)({
    url: _cloud.urls.projectName + '/check/cache/erpInfo' + '?click=click',
    method: 'get'
  });
}